import { RoutalPalette } from '@nx-smartmonkey/ui';
import { NodeRendererProps } from 'react-arborist';

import { TreeApiData } from '..';
import { DriverStopsEmptyPlaceholder } from './DriverStopsEmptyPlaceholder';

interface DriverNoStopsElementProps extends NodeRendererProps<TreeApiData> {
  hideCompleted?: boolean;
}

export const DriverNoStopsElement = ({ hideCompleted, node, style, dragHandle }: DriverNoStopsElementProps) => {
  node.isDraggable = false;
  return (
    <div
      style={{
        ...style,
        padding: 0,
        backgroundColor: RoutalPalette.neutral00,
        borderBottom: `1px solid ${RoutalPalette.neutral10}`,
      }}
      ref={dragHandle}
      onClick={() => node.toggle()}
    >
      <DriverStopsEmptyPlaceholder hideCompleted={hideCompleted} />
    </div>
  );
};
